<div class="popups-container" [class.info-mode]="infoMode">

  <!-- Info-Modus (z.B. Itu-0226) -->
  <ng-container *ngIf="infoMode">
    <div class="info-header">
      <h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
    </div>

    <mat-dialog-content>
      <p class="info-message">{{ msg }}</p>
    </mat-dialog-content>

    <div class="info-actions">
      <button [mat-dialog-close]="true" class="btn-ok">
        Verstanden
      </button>
    </div>
  </ng-container>

  <!-- Standard-Modus (Fehler / Nicht gefunden) -->
  <ng-container *ngIf="!infoMode">
    <div class="error-header">
      <span class="error-icon">&#x26A0;</span>
      <h2 mat-dialog-title class="error-title">Hinweis</h2>
    </div>

    <mat-dialog-content>
      <p class="error-message">{{ msg }}</p>
    </mat-dialog-content>

    <div class="error-actions">
      <button [mat-dialog-close]="false" class="btn-retry">
        Nochmal versuchen
      </button>
      <button [mat-dialog-close]="true" class="btn-continue">
        Weiter ohne Dienststellencode
      </button>
    </div>
  </ng-container>

</div>
